import React from 'react';
import { getEnvironmentConfig } from '@/config/environment/environment';
import { PLAYER_THEME_VARS } from '../theme';
import { EntryBuildStatus } from '../PreGame/screens/EntryBuildStatus';
import { MODES } from './HomeMode/modeCards';
import { ModeCard } from './HomeMode/ModeCard';
import '../primitives/tome/tome-tokens.css';
import './HomeMode/HomeMode.css';
export { buildModeTargetUrl } from './HomeMode/navigation';
export { shouldShowHomeModePicker } from './HomeMode/visibility';

/** Navigation choices preserve their existing route and environment permission contracts. */
export const HomeModePicker: React.FC<{ onNavigate?: (target: string) => void }> = ({ onNavigate }) => {
  const showDevOnlyModes = !getEnvironmentConfig().isProduction;
  const visible = MODES.filter(mode => !mode.devOnly || showDevOnlyModes);
  const primary = visible.filter(mode => ['/adventure', '/intro', '/resume'].includes(mode.path));
  const secondary = visible.filter(mode => mode.group === 'play' && !primary.includes(mode));
  const sandbox = visible.filter(mode => mode.group === 'sandbox');
  return <main className="home-entry tome-tokens" style={PLAYER_THEME_VARS} data-testid="home-mode-picker" aria-labelledby="home-entry-title">
    <div className="home-entry__content">
      <header className="home-entry__heading">
        <span className="home-entry__eyebrow">A world beyond the familiar</span>
        <h1 id="home-entry-title">Helix 2000</h1>
        <p>Your next chapter awaits.</p>
        <EntryBuildStatus />
      </header>
      <section data-testid="home-mode-section-play" aria-labelledby="home-play-title">
        <h2 id="home-play-title">Play</h2>
        <div className="home-entry__primary-grid">{primary.map(mode => <ModeCard key={mode.path} mode={mode} primary onNavigate={onNavigate} />)}</div>
        <h3 className="home-entry__secondary-title">More ways to visit</h3>
        <div className="home-entry__secondary-grid">{secondary.map(mode => <ModeCard key={mode.path} mode={mode} onNavigate={onNavigate} />)}</div>
      </section>
      <section className="home-entry__sandbox" data-testid="home-mode-section-sandbox" aria-labelledby="home-sandbox-title">
        <h2 id="home-sandbox-title">Sandbox · Dev</h2>
        <p className="home-entry__section-copy">Practice, explore, and build.</p>
        <div className="home-entry__secondary-grid">{sandbox.map(mode => <ModeCard key={mode.path} mode={mode} onNavigate={onNavigate} />)}</div>
      </section>
    </div>
  </main>;
};
